import React from 'react';

type Props = {
  title: string;
};

export default function Breadcrumb({ title }: Props) {
  return (
    <div className="font-circular text-2xl font-bold text-[#353535]">
      {title}
    </div>
  );
}
